import * as _ from 'lodash';

export function extractObjectData(reduxFormData, withFieldNames = false) {
  const resultObject = {};
  _.forEach(_.omitBy(reduxFormData, _.isNull), (fieldValue, id) => {
    const fieldValueObject = JSON.parse(fieldValue);
    if (withFieldNames) {
      resultObject[id] = fieldValueObject;
    } else {
      const key = _.keys(fieldValueObject)[0];
      resultObject[key] = fieldValueObject[key];
    }
  });
  return resultObject;
}
